/* In the NAme of the Father and to the Son and to The Holy Spirit Amen. St Carlos Pray for us, St Thomas Aquinas Pray for US*/
import React from 'react';
import ReactDOM from 'react-dom/client'; // Use 'react-dom/client' for React 18+
import App from './App'; 
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './i18n';

import { AuthProvider } from './auth/AuthContext'; 
import ErrorBoundary from './ErrorBoundary'; // Import the ErrorBoundary component
import SEOEventSchema from './util/SEOEventSchema'; // Import SEO schema utility

function isStageHost() {
  const host = window.location.hostname.toLowerCase();
  return host === 'stage.graceanointing.org' || host === 'stage.graceanoiinting.org';
}

function enforceNoIndexForStage() {
  if (!isStageHost()) return;

  let robotsMeta = document.querySelector('meta[name="robots"]');
  if (!robotsMeta) {
    robotsMeta = document.createElement('meta');
    robotsMeta.setAttribute('name', 'robots');
    document.head.appendChild(robotsMeta);
  }
  robotsMeta.setAttribute('content', 'noindex, nofollow, noarchive, nosnippet, noimageindex');

  let googlebotMeta = document.querySelector('meta[name="googlebot"]');
  if (!googlebotMeta) {
    googlebotMeta = document.createElement('meta');
    googlebotMeta.setAttribute('name', 'googlebot');
    document.head.appendChild(googlebotMeta);
  }
  googlebotMeta.setAttribute('content', 'noindex, nofollow, noarchive, nosnippet, noimageindex');
}

// Load CSS file from environment variable
const cssPath = `${process.env.REACT_APP_URL}/styles/css/bootstrap.min.css`; // Ensure REACT_APP_URL is defined in your .env file
const link = document.createElement('link');
link.rel = 'stylesheet';
link.href = cssPath;
document.head.appendChild(link);  
function hideInitialSpinner() {
  const spinner = document.getElementById('spinner');
  if (!spinner) return;

  spinner.classList.remove('show');
  spinner.style.visibility = 'hidden';
  spinner.style.opacity = '0';
  spinner.style.display = 'none';
}

// Create a root to render the App
const root = ReactDOM.createRoot(document.getElementById('root'));

// Stage site must never be indexed.
enforceNoIndexForStage();

// Initialize SEO event schemas for Google indexing
if (!isStageHost()) {
  SEOEventSchema.initializeEventSchema();
}

// Render the application with AuthProvider
root.render(
  <React.StrictMode>
    <AuthProvider>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </AuthProvider>
  </React.StrictMode>
);

// Fail-safe: prevent template spinner from persisting on deep links.
hideInitialSpinner();
